<template>
  <div>
    <div
      class="modal fade deleteProductModal"
      id="deleteProductModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteProductModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body my-row">
            <h2>Opravdu chceš smazat produkt?</h2>
            <div class="my-row">
              <button class="btn-gray" data-bs-dismiss="modal">Ne</button>
              <button class="btn-yellow" v-on:click="deleteProduct()">
                Ano, smazat!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h2>Přehled produktů</h2>
    <ul class="productsList">
      <template v-for="product in products">
        <li>
          <div class="productsList__nameImageWrapper">
            <img
              v-if="product.image_urls"
              :src="
                product.color_name
                  ? this.imagesBasePath +
                    product.name +
                    '-' +
                    product.color_name +
                    '/' +
                    product.image_urls[0]
                  : product.variant
                  ? this.imagesBasePath +
                    product.name +
                    '-' +
                    product.variant +
                    '/' +
                    product.image_urls[0]
                  : this.imagesBasePath +
                    product.name +
                    '/' +
                    product.image_urls[0]
              "
              alt=""
            />
            <span class="productsList__name__wrapper">
              <span class="productsList__name">
                {{
                  product.color_name || product.variant
                    ? product.name + ", "
                    : product.name
                }}
                {{ product.color_name ?? "" }}
                {{ product.variant ?? "" }}
              </span>
              <ul class="productsList__name__wrapper__buttons">
                <template
                  v-if="
                    product.name !== 'Nezařazeny' &&
                    product.name !== 'Bez kategorií'
                  "
                >
                  <router-link :to="'/admin/' + product.id"
                    >Editovat</router-link
                  >
                  <li v-on:click="hideProduct(product.id)">
                    {{ product.isActive ? "Schovat" : "Zobrazovat" }}
                  </li>
                  <li v-on:click="showConfirmModal(product.id)">Smazat</li>
                </template>
                <font-awesome-icon
                  v-if="product.children?.length > 0"
                  :icon="['fa', 'angle-down']"
                  :size="'2x'"
                  v-on:click="product.showChildren = !product.showChildren"
                  :class="{ rotated: product.showChildren }"
                />
              </ul>
            </span>
          </div>
          <ul v-if="product.showChildren">
            <li v-for="child in product.children" :key="child?.id">
              <img
                v-if="child?.image_urls"
                :src="
                  child?.color_name
                    ? this.imagesBasePath +
                      child?.name +
                      '-' +
                      child?.color_name +
                      '/' +
                      child?.image_urls[0]
                    : child?.variant
                    ? this.imagesBasePath +
                      child?.name +
                      '-' +
                      child?.variant +
                      '/' +
                      child?.image_urls[0]
                    : this.imagesBasePath +
                      child?.name +
                      '/' +
                      child?.image_urls[0]
                "
                alt=""
              />
              <span class="productsList__name__wrapper">
                <span class="productsList__name">
                  {{
                    child?.color_name || child?.variant
                      ? child?.name + ", "
                      : child?.name
                  }}
                  {{ child?.color_name ?? "" }}
                  {{ child?.variant ?? "" }}
                </span>
                <ul class="productsList__name__wrapper__buttons">
                  <router-link :to="'/admin/' + child?.id"
                    >Editovat</router-link
                  >
                  <li v-on:click="hideProduct(child?.id)">
                    {{ child?.isActive ? "Schovat" : "Zobrazovat" }}
                  </li>

                  <li v-on:click="showConfirmModal(child?.id)">Smazat</li>
                </ul>
              </span>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import axios from "../../api";
import * as bootstrap from "bootstrap";

export default {
  components: {},
  data() {
    return {
      products: [],
      productToBeRemoved: null,
      imagesBasePath: `${process.env.VUE_APP_FITMO_BACKEND_URL}/products/`,
    };
  },

  methods: {
    async getAllProducts() {
      try {
        const response = await axios.get("/api/soloProducts");

        this.products = response.data;
        console.log(response.data.filter((item) => item.parent_id == null));
      } catch (error) {
        console.log(error);
      }
    },
    showConfirmModal(id) {
      this.productToBeRemoved = id;
      const modal = new bootstrap.Modal(
        document.getElementById("deleteProductModal")
      );
      modal.show();
    },
    async deleteProduct() {
      const modalElement = document.getElementById("deleteProductModal");
      if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement);
        if (modal) {
          modal.hide();
        }
      }
      await axios
        .delete("/api/product/" + this.productToBeRemoved, {
          headers: {
            Authorization: "",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.getAllProducts();
            this.$snackbar.add({
              type: "success",
              text: "Jsi moc šikovný kluk 🎸!",
            });
          } else {
            this.$snackbar.add({
              type: "error",
              text: "Něco se 💩. Radši zavolej Márovi, než to celý rozbiješ.",
            });
          }
        })
        .catch((error) => {
          this.$snackbar.add({
            type: "error",
            text:
              error.response.data.error ??
              "Něco se 💩. Radši zavolej Márovi, než to celý rozbiješ.",
          });
          console.log(error);
        });
    },

    async hideProduct(id) {
      await axios
        .put("/api/product/" + id + "/hide", {
          headers: {
            Authorization: "",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.getAllProducts();
            this.$snackbar.add({
              type: "success",
              text: "Jsi moc šikovný kluk 🎸!",
            });
          } else {
            this.$snackbar.add({
              type: "error",
              text: "Něco se 💩. Radši zavolej Márovi, než to celý rozbiješ.",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.getAllProducts();
  },
};
</script>
<style lang="scss">
.productsList {
  gap: 1rem;
  display: flex;
  flex-direction: column;

  img {
    width: 80px;
    object-fit: contain;
    object-position: top;
  }

  &__nameImageWrapper {
    display: flex;
    gap: 1rem;
  }

  .rotated {
    transform: rotateX(180deg);
  }

  & > li {
    border-bottom: 1px solid $gray-second;
    padding: 1rem 0;
    display: flex;
    flex-direction: column;

    li {
      display: flex;
      gap: 1rem;

      > ul {
        display: flex;
        flex-direction: column;
      }
    }
  }

  &__name {
    font-weight: 500;
    font-size: 1.5rem;

    &__wrapper {
      &__buttons {
        display: flex;
        gap: 2rem;
        font-size: 1.3rem;

        & > li {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
